import { Box, Flex, Text, Image, Link, Icon, Grid, Separator} from "@chakra-ui/react";
import logo from "../images/logo.png";
import { FaFacebook, FaInstagram, FaWhatsapp, FaEnvelope, FaLocationDot } from "react-icons/fa6";

const Links = [
    {"name":"About","link":"/about"},
    {"name":"Services","link":"/service"}
];

const NavLink = ({ src,children }) => (
  <Link
    variant="plain" 
    href={src}
    color="white"
    textStyle={{ base:'sm', lg:'md' }}
    _hover={{ color: "blue.300" }}
  >
    {children}
  </Link>
);

const Footer = () => {
    return (
        <Box bg='blue.300' maxW='100%' overflowX="hidden" flexWrap='wrap'>
            <Flex direction="column" color='white'>
                <Flex direction="row" align='center' w='100%' maxW="100%" flexWrap="wrap" justify="space-around">
                    <Flex direction="row" align='center'>
                        <Image height="100px" src={logo} />
                        <Flex direction="column">
                            <Flex direction="row" align='center'>
                                <Text textStyle="lg" fontWeight="bold" color='green.600' mr='1'>Ikhlas</Text>
                                <Text textStyle="lg" fontWeight="bold" color='blue.500' mr='1'>Bangun</Text>
                                <Text textStyle="lg" fontWeight="bold" color='gray.600'>Griya</Text>
                            </Flex>
                            <Text textStyle="sm" fontWeight="bold" color='gray.500'>Bangun Griya Wujudkan Asa</Text>
                        </Flex>
                    </Flex>
                    <Flex direction="row" justify="space-around" flexWrap="wrap" spaceX="3" w="100%" borderTopRadius={10} p={4} bg='blue.500' boxShadow="md">
                        <Flex direction="column" marginRight={{'base':0,'md':8}} marginBottom={{'base':7,'md':0}} align={{'base':'center','md':'start'}}>
                            <Text fontSize={{ base:'md', lg:'lg' }} fontWeight="bold">Links</Text>
                            <Separator w="100%" mb="1"/>
                            {Links.map((link) => (
                                <NavLink key={link.name} src={link.link}>{link.name}</NavLink>
                            ))}
                            <NavLink key="showroom" src="/showroom">Showroom</NavLink>
                        </Flex>
                        <Flex direction="column" align={{'base':'center','md':'start'}} marginBottom={{'base':7,'md':0}}>
                            <Text fontSize={{ base:'md', lg:'lg' }} fontWeight="bold">Contact Us</Text>
                            <Separator w="100%" mb="1"/>
                            <Grid templateColumns="minmax(0, 30px) minmax(0, 200px)" placeItems="center" gap="1" textStyle={{ base:'sm', lg:'md' }}>
                                <Icon as={FaWhatsapp} w={6} h={6} color="green.400" />
                                <Link href="https://wa.me/62882008354419" color="white" w="100%" isExternal>
                                    +62 8820-0835-4419
                                </Link>
                                <Icon as={FaEnvelope} w={6} h={6} color="blue.800" />
                                <Link href="mail:ikhlasbangungriya@gmail.com" w="100%" color="white">
                                    ikhlasbangungriya@gmail.com
                                </Link>
                                <Icon as={FaLocationDot} w={6} h={6} color="red.500" />
                                <Text textWrap="wrap" w="100%">
                                    Jln. Gadjah Mada No.42 Bolon, Colomadu, Karanganyar
                                </Text>
                            </Grid>
                        </Flex>
                        <Flex direction="column" align={{'base':'center','md':'start'}}>
                            <Text fontSize={{ base:'md', lg:'lg' }} fontWeight="bold">Follow Me On</Text>
                            <Separator w="100%" mb="1"/>
                            <Flex spaceX="1">
                                <Link href="https://www.facebook.com/ikhlasbangungriya/" isExternal>
                                    <Icon as={FaFacebook} w={6} h={6} color="blue.800" />
                                </Link>
                                <Link href="https://www.instagram.com/ikhlas_bangun_griya/" isExternal>
                                    <Icon as={FaInstagram} w={6} h={6} color="pink.500" />
                                </Link>
                            </Flex>
                        </Flex>
                    </Flex>
                </Flex>
                <Text textAlign='center' bg='blue.600'>
                    © 2025 Ikhlas Bangun Griya. All rights reserved.
                </Text>
            </Flex>
        </Box>
    );
}

export default Footer;